import React from "react";
import {
  Activity,
  BookOpen,
  Building2,
  CalendarDays,
  ChevronDown,
  FileText,
  FolderKanban,
  Mail,
  PanelLeft,
  Send,
  ShieldCheck,
  SlidersHorizontal,
  UserCheck,
  Users,
} from "lucide-react";

// Icon beside each section heading, by the `group` name pages give their
// fields. Add an entry when a page introduces a new group; unknown groups
// fall back to the generic filter icon.
const GROUP_ICONS = {
  Access: ShieldCheck,
  Account: UserCheck,
  Activity: Activity,
  Article: BookOpen,
  Audience: Users,
  Dates: CalendarDays,
  Delivery: Send,
  Details: FileText,
  Email: Mail,
  Organization: Building2,
  Project: FolderKanban,
  Sidebar: PanelLeft,
};

// A collapsible card holding one group of filter fields. The header shows how
// many of its fields are set, so a collapsed section still reads at a glance.
const FilterSection = ({ title, activeCount, collapsed, onToggle, children }) => {
  const Icon = GROUP_ICONS[title] || SlidersHorizontal;

  return (
    <section className="rounded-lg border border-border bg-surface">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={!collapsed}
        className="w-full flex items-center gap-2.5 px-3.5 py-3 text-left"
      >
        <span className="flex-shrink-0 inline-flex items-center justify-center h-7 w-7 rounded-md bg-primary_tint text-primary">
          <Icon size={15} />
        </span>
        <span className="flex-1 min-w-0 truncate text-[13px] font-semibold text-text_primary">{title || "General"}</span>
        {activeCount > 0 && (
          <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-primary text-white text-[10px] font-semibold leading-none">
            {activeCount}
          </span>
        )}
        <ChevronDown size={16} className={`flex-shrink-0 text-text_muted ${collapsed ? "" : "rotate-180"}`} />
      </button>

      {!collapsed && <div className="px-3.5 pb-3.5 pt-0.5 space-y-3.5">{children}</div>}
    </section>
  );
};

export default FilterSection;
